import DocumentationButton from "components/DocumentationButton";
import { LogoAzureColored } from "components/icons/generated";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import { getDocsUrl } from "utils/getDocsUrl";
import { ANALYTICS } from "views/Account/CloudIntegrations/List/constants";

const AzureIntegrationFormDrawerEmptyState = () => {
  return (
    <Box>
      <EmptyState
        title="Azure integration"
        caption="The managed Azure integration is not enabled in your Spacelift installation, but you can still use OIDC Federation. Learn how to do it by clicking on the button below."
        icon={LogoAzureColored}
        padding="x-large"
      >
        <DocumentationButton
          analyticsPage={ANALYTICS.analyticsPage}
          analyticsTitle="Azure documentation button clicked"
          to={getDocsUrl("/integrations/cloud-providers/oidc/azure-oidc")}
          label="Documentation"
        />
      </EmptyState>
    </Box>
  );
};

export default AzureIntegrationFormDrawerEmptyState;
